import React from 'react';

const PostHeader = () => null;

export default PostHeader;
